const Content = [
	{
		companyName: "Starlabs",
		job: "Intern",
		description:
			"Worked on a project with a team of 5 people including the teamleader who was a developer at Starlabs",
		dates: {
			startMonth: "June",
			startYear: "2020",
			endMonth: "August",
			endYear: "2020",
		},
	},
];

export default Content;